import { render, staticRenderFns } from "./MessageThreadsHideConfirm.vue?vue&type=template&id=d0457cae&"
import script from "./MessageThreadsHideConfirm.vue?vue&type=script&lang=ts&"
export * from "./MessageThreadsHideConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports